import src from "IMAGE";
export default { src, width: 512, height: 512, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
